import { redirectToPage } from '../../store/dataCapture';
import {
  ROUTE_OLD_SIGNATORIES_PAGE,
  ROUTE_SWITCH_BUSINESS_PAGE,
  ROUTE_ALMOST_THERE_PAGE,
  ROUTE_OLD_ACCOUNT_DETAILS_PAGE,
  ROUTE_SWITCH_DATE_PAGE
} from '../../utils/constants';
import { submitMicroenterprise } from './service.actions';

export const SAVE_OLD_SIGNATORIES = 'SAVE_OLD_SIGNATORIES';
export const UPDATE_OLD_SIGNATORIES = 'UPDATE_OLD_SIGNATORIES';
export const DELETE_OLD_SIGNATORIES = 'DELETE_OLD_SIGNATORIES';
export const SAVE_ALMOST_THERE_FORM = 'SAVE_ALMOST_THERE_FORM';
export const SAVE_SWITCH_BUSINESS_FORM = 'SAVE_SWITCH_BUSINESS_FORM';
export const SAVE_OLD_ACCOUNT_DETAILS_FORM = 'SAVE_OLD_ACCOUNT_DETAILS_FORM';
export const SAVE_OLD_SIGNATORIES_FORM = 'SAVE_OLD_SIGNATORIES_FORM';
export const SAVE_OLD_ADD_SIGNATORY_FORM = 'SAVE_OLD_ADD_SIGNATORY_FORM';
export const SAVE_SWITCH_DATE_FORM = 'SAVE_SWITCH_DATE_FORM';
export const SAVE_APPLICATION_COMPLETE_FORM = 'SAVE_APPLICATION_COMPLETE_FORM';
export const REDIRECT_OFFER_PAGE = 'redirect_to_offer';
export const RESET_CONFIRM_SWITCH_ERROR = 'RESET_CONFIRM_SWITCH_ERROR';
export const addOldSignatories = data => ({
  type: SAVE_OLD_SIGNATORIES,
  data,
  meta: {
    nextAction: redirectToPage(ROUTE_OLD_SIGNATORIES_PAGE)
  }
});

export const updateOldSignatories = (data, index) => ({
  type: UPDATE_OLD_SIGNATORIES,
  data,
  meta: {
    nextAction: redirectToPage(ROUTE_OLD_SIGNATORIES_PAGE),
    index: index
  }
});

export const removeOldSignatories = index => ({
  type: DELETE_OLD_SIGNATORIES,
  index,
  meta: {
    nextAction: redirectToPage(ROUTE_OLD_SIGNATORIES_PAGE)
  }
});

export const saveAlmostThereForm = data => ({
  type: SAVE_ALMOST_THERE_FORM,
  data,
  path: ROUTE_SWITCH_BUSINESS_PAGE
});
export const saveSwitchBusinessForm = data => ({
  type: SAVE_SWITCH_BUSINESS_FORM,
  data,
  path: ROUTE_OLD_ACCOUNT_DETAILS_PAGE
});
export const saveOldAccountDetailsForm = (data, isSoleTrader) => ({
  type: SAVE_OLD_ACCOUNT_DETAILS_FORM,
  data,
  path: isSoleTrader ? ROUTE_SWITCH_DATE_PAGE : ROUTE_OLD_SIGNATORIES_PAGE
});

export const saveOldAddSignatoryForm = data => ({
  type: SAVE_OLD_SIGNATORIES_FORM,
  data,
  path: ROUTE_SWITCH_DATE_PAGE
});

export const saveSwitchDateForm = (data, isSoleTrader, selectedDate) => ({
  type: SAVE_SWITCH_DATE_FORM,
  data,
  meta: {
    nextAction: submitMicroenterprise(isSoleTrader, selectedDate)
  }
});
export const saveApplicationCompleteForm = data => ({
  type: SAVE_APPLICATION_COMPLETE_FORM,
  data
});

export const redirectToAlmostTherePage = data => ({
  type: REDIRECT_OFFER_PAGE,
  data,
  path: ROUTE_ALMOST_THERE_PAGE
});

export const resetConfirmSwitchError = data => ({
  type: RESET_CONFIRM_SWITCH_ERROR,
  data
});
